import * as Lightcharts from '../lightcharts';
export function use(installable) {
    if (Array.isArray(installable)) {
        installable.forEach(function (item) { return item.install(Lightcharts); });
    }
    else {
        installable.install(Lightcharts);
    }
}
